import { IonButton, IonIcon } from '@ionic/react';
import React from 'react';

import { useInView } from '@/hooks';
import { checkmarkOutline } from 'ionicons/icons';

import './Plan.css';

interface PlanProps {
  title: string;
  description: string;
  originalPrice: number;
  price: number;
  discountPercentage: number;
  isPopular?: boolean;
}

const Plan: React.FC<PlanProps> = ({
  title,
  description,
  originalPrice,
  price,
  discountPercentage,
  isPopular = false
}) => {
  const benefits = [
    'Unlimited appointments',
    'Unlimited patient reminders',
    'Exclusive booking website',
    'All features included'
  ];

  const [ref, inView] = useInView({
    triggerOnce: true
  });

  const requestDemo = () => {
    window.open('https://m.me/OdontoPhilippines', '_blank');
  };

  return (
    <div
      className={`plan ${isPopular ? 'plan--popular' : ''} ${inView ? 'plan--in-view' : ''}`}
      ref={ref}
    >
      {isPopular && <div className="plan__badge">Most Popular</div>}

      <div className="plan__header">
        <p className="plan__title">{title}</p>
        <p className="plan__description">{description}</p>
      </div>

      <div className="plan__price">
        <div className="plan__price-container">
          <div className="plan__discount-badge">-{discountPercentage}%</div>
          <div className="plan__original-price">
            <span className="plan__currency">₱</span>
            <span className="plan__amount">
              {originalPrice.toLocaleString()}
            </span>
          </div>
          <div className="plan__current-price">
            <span className="plan__currency">₱</span>
            <span className="plan__amount">{price.toLocaleString()}</span>
            <span className="plan__period">per month</span>
          </div>
        </div>
      </div>

      <div className="plan__benefits">
        {benefits.map((benefit, benefitIndex) => (
          <div key={benefitIndex} className="plan__benefit">
            <IonIcon
              icon={checkmarkOutline}
              className="plan__benefit-icon"
              color="success"
            />
            <p className="plan__benefit-text">{benefit}</p>
          </div>
        ))}
      </div>

      <IonButton strong onClick={requestDemo} className="plan__request-demo">
        Request a demo
      </IonButton>

      <p className="plan__trial">1-week free trial. Cancel anytime.</p>
    </div>
  );
};

export default Plan;
